export const cleanStorage = (
  names: string[],
  storage: 'sessionStorage' | 'localStorage'
) => {
  names.forEach((name) => {
    window[storage].removeItem(name);
  });
};
